<template>
  <div class="my-modal-wrap">
    <div class="my-modal-bg" @click="closeMyModal"></div>
      <slot></slot>
  </div>
</template>

<script>
  export default {
    methods: {
      closeMyModal () {
        this.$emit('closeMyModal');
      }
    }
  }
</script>

<style lang="scss">
  .my-modal-wrap {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1000;
    &>div {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .my-modal-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/MyModal.vue